import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
  InputLabel,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Stack,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import EditIcon from "@mui/icons-material/Edit";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Remove } from "@mui/icons-material";
import { authPost } from "../../../util/request/authPost";
import { authPut } from "../../../util/request/authPut";
import CustomDateInput from "../../../Components/customDateInput";
const TripBookingModal = ({
  handleClose,
  onSave,
  reFreshData,
  initialData = {},
}) => {
  dayjs.extend(utc); // Enables UTC support
  dayjs.extend(timezone); // Enables timezone support
  const [formData, setFormData] = useState({
    date: null,
    guestCount: "",
    costPerGuest: 15,
    client: "",
    contact: "",
    email: "",
    items: [],
    non_refund_deposite: "",
    non_refund_deposite_date: null,
    booking_status: "",
    note: null,
    bill_address1: "",
    bill_address2: "",
    bill_city: "",
    bill_state: "",
    bill_zipcode: "",
    taxFree: false,
  });
  const [newItem, setNewItem] = useState({ description: "", price: "" });
  const [open, setOpen] = useState(false);
  const [openChangeDate, setOpenChangeDate] = useState(false);
  const [cancelChecked, setCancelChecked] = React.useState(false);

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setFormData((prev) => ({
        ...prev,
        ...initialData,
        date: initialData.date ? initialData.date : prev.date,
        email: initialData.email ? initialData.email : "",
        non_refund_deposite_date: initialData.non_refund_deposite_date
          ? dayjs(initialData.non_refund_deposite_date)
          : prev.non_refund_deposite_date,
        items: initialData.items || [],
        note: initialData.note,
        bill_address1: initialData.bill_address1,
        bill_address2: initialData.bill_address2,
        bill_city: initialData.bill_city,
        bill_state: initialData.bill_state,
        bill_zipcode: initialData.bill_zipcode,
        taxFree: initialData.taxFree || false,
      }));
    }
  }, [initialData]);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleNewItemChange = (e) => {
    setNewItem({ ...newItem, [e.target.name]: e.target.value });
  };

  const addItem = () => {
    if (newItem.description && newItem.price) {
      setFormData({
        ...formData,
        items: [...formData.items, newItem],
      });
      setNewItem({ description: "", price: "" });
    }
  };

  const removeItem = (index) => {
    setFormData({
      ...formData,
      items: formData.items.filter((_, i) => i !== index),
    });
  };

  const handleDateChange = (name, date) => {
    console.log(date);
    setFormData({ ...formData, [name]: date });
  };

  const handleSubmit = async () => {
    if (formData._id) {
      const result = await authPut({
        subLink: "fieldtrip",
        id: formData._id,
        data: {
          ...formData,
          booking_status: cancelChecked ? "canceled" : "booked",
        },
      });
      if (result.status === "success") {
        setFormData({
          date: null,
          guestCount: "",
          costPerGuest: 15,
          client: "",
          contact: "",
          email: "",
          items: [],
          non_refund_deposite: "",
          non_refund_deposite_date: null,
          booking_status: "",
          note: null,
          bill_address1: "",
          bill_address2: "",
          bill_city: "",
          bill_state: "",
          bill_zipcode: "",
          taxFree: false,
        });
        setCancelChecked(false);
        setOpenChangeDate(false);
        setOpen(false);
        reFreshData();
      }
    } else {
      const result = await authPost({
        subLink: "fieldtrip",
        data: {
          ...formData,

          booking_status: "booked",
        },
      });
      if (result.status === "success") {
        setFormData({
          date: null,
          guestCount: "",
          costPerGuest: 15,
          client: "",
          contact: "",
          email: "",
          items: [],
          non_refund_deposite: "",
          non_refund_deposite_date: null,
          booking_status: "",
          note: null,
          bill_address1: "",
          bill_address2: "",
          bill_city: "",
          bill_state: "",
          bill_zipcode: "",
          taxFree: false,
        });
        setCancelChecked(false);
        setOpenChangeDate(false);
        setOpen(false);
        reFreshData();
      }
    }
  };
  // console.log(formData.date);

  return (
    <div>
      <Button
        variant="contained"
        onClick={() => setOpen(true)}
        sx={{
          marginTop: "20px",
          marginBottom: "20px",
          maxWidth: "100px",
        }}
        startIcon={<EditIcon></EditIcon>}
      >
        {initialData._id ? "Edit" : "Create"}
      </Button>
      {open && (
        <div>
          <Modal open={open} onClose={handleClose}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "background.paper",
                boxShadow: 24,
                paddingX: 4,
                borderRadius: 2,
                width: { xs: "350px", sm: "500px", md: "800px", lg: "800px" },
                height: "90%",
                overflowY: "auto",
              }}
            >
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                {formData._id
                  ? "Editing"
                  : // <>
                    //   <Box>Field Trip on {initialData.date.slice(5)}</Box>
                    //   <Box>{"To change the date, pick a new date below"}</Box>
                    // </>
                    "Create Booking"}
              </Typography>
              {/* {formData.date} */}
              {!formData._id && (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    required
                    label="Date"
                    name="date"
                    format={"MM/DD/YYYY"}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        date: dayjs(e).format("YYYY-MM-DD"),
                      });
                    }}
                    sx={{
                      mt: "30px",
                      width: "180px",
                    }}
                  />
                </LocalizationProvider>
              )}
              {formData._id && (
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={2}
                  mb="20px"
                >
                  <Box>Trip Date</Box>
                  <Box>
                    {formData.date.slice(5)}-{formData.date.slice(0, 4)}
                  </Box>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => setOpenChangeDate((prev) => !prev)}
                  >
                    Change
                  </Button>
                </Stack>
              )}
              {openChangeDate && (
                <Stack
                  sx={{
                    border: "2px solid #7095e5",
                    padding: "10px",
                    borderRadius: "5px",
                    mb: "20px",
                  }}
                >
                  <Box
                    sx={{
                      mb: "10px",
                      width: "180px",
                    }}
                  >
                    Change Date to{" "}
                  </Box>
                  <Box>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        required
                        label="Date"
                        name="date"
                        format={"MM/DD/YYYY"}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            date: dayjs(e).format("YYYY-MM-DD"),
                          });
                        }}
                        sx={{
                          mb: "30px",
                          width: "180px",
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Stack>
              )}

              <TextField
                required
                fullWidth
                margin="dense"
                label="How many guests"
                name="guestCount"
                // variant="standard"
                type="number"
                InputProps={{
                  inputProps: {
                    max: 100,
                    min: 10,
                  },
                }}
                value={formData.guestCount}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                margin="dense"
                label="Cost Per Guest"
                name="costPerGuest"
                type="number"
                disabled
                required
                value={formData.costPerGuest}
                onChange={handleChange}
              />
              <TextField
                required
                fullWidth
                margin="dense"
                label="Client"
                name="client"
                value={formData.client}
                onChange={handleChange}
              />
              <TextField
                required
                fullWidth
                margin="dense"
                label="Contact"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
              />

              <TextField
                fullWidth
                margin="dense"
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />

              <Typography variant="subtitle1" mt={2}>
                Items
              </Typography>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}
              >
                <TextField
                  fullWidth
                  margin="dense"
                  label="Description"
                  name="description"
                  value={newItem.description}
                  onChange={handleNewItemChange}
                />
                <TextField
                  margin="dense"
                  label="Price"
                  name="price"
                  type="number"
                  value={newItem.price}
                  onChange={handleNewItemChange}
                />
                <Button onClick={addItem} variant="contained" color="primary">
                  Add
                </Button>
              </Box>
              {formData.items.length > 0 && (
                <Box
                  mt={2}
                  p={2}
                  sx={{ backgroundColor: "#f5f5f5", borderRadius: 1 }}
                >
                  <Typography variant="subtitle1">Added Items:</Typography>
                  {formData.items.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mt: 1,
                      }}
                    >
                      <Typography>
                        {item.description} - ${item.price}
                      </Typography>
                      <IconButton
                        onClick={() => removeItem(index)}
                        color="error"
                      >
                        <Remove />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              )}

              <FormControl fullWidth margin="dense" sx={{ marginTop: "40px" }}>
                <InputLabel htmlFor="outlined-adornment-amount">
                  Deposit Amount*
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-amount"
                  startAdornment={
                    <InputAdornment position="start">$</InputAdornment>
                  }
                  label="Non-Refund Deposit"
                  name="non_refund_deposite"
                  type="number"
                  value={formData.non_refund_deposite}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl fullWidth margin="dense">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Non-Refund Deposit Date*"
                    value={formData.non_refund_deposite_date}
                    onChange={(date) =>
                      handleDateChange("non_refund_deposite_date", date)
                    }
                    renderInput={(params) => (
                      <TextField fullWidth margin="dense" {...params} />
                    )}
                  />
                </LocalizationProvider>
              </FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.taxFree}
                    onChange={(e) =>
                      setFormData({ ...formData, taxFree: e.target.checked })
                    }
                  />
                }
                label="Tax Exempt"
              />
              {/* <Checkbox
                checked={formData.taxFree}
                onChange={(e) =>
                  setFormData({ ...formData, taxFree: e.target.checked })
                }
                label="Tax Free"
              /> */}
              <TextField
                fullWidth
                margin="dense"
                label="Note"
                name="note"
                value={formData.note}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                margin="dense"
                label="Street"
                name="bill_address1"
                value={formData.bill_address1}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                margin="dense"
                label="Address 2 (Option)"
                name="bill_address2"
                value={formData.bill_address2}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                margin="dense"
                label="City"
                name="bill_city"
                value={formData.bill_city}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                margin="dense"
                label="State"
                name="bill_state"
                value={formData.bill_state}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                margin="dense"
                label="Zipcode"
                name="bill_zipcode"
                value={formData.bill_zipcode}
                onChange={handleChange}
              />
              {/* 
bill_address1: "",
    bill_address2: "",
    bill_city: "",
    bill_state: "",
    bill_zipcode: "", */}

              {/* <TextField
          fullWidth
          margin="dense"
          label="Booking Status"
          name="booking_status"
          value={formData.booking_status}
          onChange={handleChange}
        /> */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                  mb: 4,
                }}
              >
                <Button
                  onClick={() => {
                    setOpen(false);

                    setCancelChecked(false);
                    setOpenChangeDate(false);
                  }}
                  variant="outlined"
                >
                  Cancel
                </Button>
                {formData._id && (
                  <FormControlLabel
                    control={<Checkbox />}
                    label="Cancel this field trip"
                    onChange={(e) => setCancelChecked(e.target.checked)}
                  />
                )}
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  color="primary"
                >
                  {cancelChecked ? "Delete" : "Save"}
                </Button>
              </Box>
            </Box>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default TripBookingModal;
